export default "__VITE_ASSET__336efff8__"